import Spinner from "components/Spinner";

const STATUS_COLOR_MAP = {
  blue: "bg-blue-100 text-blue-800",
  red: "bg-red-100 text-red-800",
  purple: "bg-purple-100 text-purple-800",
  green: "bg-green-100 text-green-800",
  gray: "bg-gray-100 text-gray-800",
} as const;

export const getStatusColorClass = (color?: string): string => {
  if (!color) return STATUS_COLOR_MAP.gray;
  return STATUS_COLOR_MAP[color.toLowerCase() as keyof typeof STATUS_COLOR_MAP] || STATUS_COLOR_MAP.gray;
};

export const StatusBadge = ({ label, color, spinner }: { label: string; color?: string; spinner?: boolean }) => (
  <span className={`inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md ${getStatusColorClass(color)}`}>
    {spinner && <Spinner size="XXS" theme="secondary" className="mr-1.5 !text-gray-800" />}
    {label}
  </span>
);

export default StatusBadge;
